import { useCallback, useState } from "react";
import { message } from "antd";
import { audbilityApi } from "../../shared/services/audbilityApi";
import { normalizeUser } from "../../shared/utils/audbilityFormatters";
import {
  LOAD_USER_DETAILS_ERROR_MESSAGE,
  LOAD_USER_LOGS_ERROR_MESSAGE,
  LOAD_USER_PATIENTS_ERROR_MESSAGE,
} from "../constants";
import { AUDBILITY_USER_DETAILS_MOCK } from "../mocks/audbilityUserDetailsMock";
import { normalizeLogs } from "../utils/logFormatters";
import { normalizePatients } from "../utils/patientFormatters";

export const useAudbilityUserDetails = (sub) => {
  const [userDetails, setUserDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [logs, setLogs] = useState([]);
  const [isLoadingLogs, setIsLoadingLogs] = useState(false);
  const [patients, setPatients] = useState([]);
  const [isLoadingPatients, setIsLoadingPatients] = useState(false);

  const getUserDetails = useCallback(async () => {
    try {
      setIsLoading(true);

      const getUserBySub = await audbilityApi.getUserBySub(sub);

      // TODO: triagens, pacientes e compras ainda são mock — ver SPRINT.md seção 14.1
      setUserDetails(
        getUserBySub
          ? {
              ...normalizeUser(getUserBySub),
              ...AUDBILITY_USER_DETAILS_MOCK,
            }
          : null
      );
    } catch (error) {
      console.log("Erro ao buscar detalhes do usuário Audbility: ", error);
      message.error(LOAD_USER_DETAILS_ERROR_MESSAGE);
      setUserDetails(null);
    } finally {
      setIsLoading(false);
    }
  }, [sub]);

  const getUserLogs = useCallback(async () => {
    try {
      setIsLoadingLogs(true);

      const response = await audbilityApi.getUserLogs(sub);

      setLogs(normalizeLogs(response?.logs || []));
    } catch (error) {
      console.log("Erro ao buscar logs do usuário Audbility: ", error);
      message.error(LOAD_USER_LOGS_ERROR_MESSAGE);
      setLogs([]);
    } finally {
      setIsLoadingLogs(false);
    }
  }, [sub]);

  const getUserPatients = useCallback(async () => {
    try {
      setIsLoadingPatients(true);

      const response = await audbilityApi.getUserPatients(sub);

      setPatients(normalizePatients(response?.patients || []));
    } catch (error) {
      console.log("Erro ao buscar pacientes do usuário Audbility: ", error);
      message.error(LOAD_USER_PATIENTS_ERROR_MESSAGE);
      setPatients([]);
    } finally {
      setIsLoadingPatients(false);
    }
  }, [sub]);

  return {
    userDetails,
    isLoading,
    getUserDetails,
    logs,
    isLoadingLogs,
    getUserLogs,
    patients,
    isLoadingPatients,
    getUserPatients,
  };
};
